import * as React from 'react'

import { palette } from 'main/ui'
import { SVGResponsive } from './common'

function Bank() {
  return (
    <SVGResponsive height={39} width={33}>
      <path
        d="M16.1698 0.0735796L0.442493 8.67231C0.174359 8.81888 0 9.1599 0 9.53763V12.922C0 13.4406 0.32374 13.8609 0.723094 13.8609H32.1777C32.577 13.8609 32.9008 13.4406 32.9008 12.922V9.53763C32.9008 9.1599 32.7264 8.81888 32.4583 8.67231L16.731 0.0735796C16.5515 -0.0245265 16.3492 -0.0245265 16.1698 0.0735796Z"
        fill={palette.mediumGray}
      />
      <path
        d="M4.53264 15.5936C4.13331 15.5936 3.80955 15.9764 3.80955 16.4487V31.9387C3.80955 31.9508 3.80976 31.9628 3.8102 31.9747H0.723094C0.32374 31.9747 0 32.3575 0 32.8298V37.2626C0 37.7348 0.32374 38.1176 0.723094 38.1176H32.1777C32.577 38.1176 32.9008 37.7348 32.9008 37.2626V32.8298C32.9008 32.3575 32.577 31.9747 32.1777 31.9747H29.0906C29.091 31.9628 29.0912 31.9508 29.0912 31.9387V16.4487C29.0912 15.9764 28.7675 15.5936 28.3681 15.5936H24.6194C24.2201 15.5936 23.8963 15.9764 23.8963 16.4487V31.9387C23.8963 31.9508 23.8965 31.9628 23.897 31.9747H19.0472C19.0476 31.9628 19.0478 31.9508 19.0478 31.9387V16.4487C19.0478 15.9764 18.7241 15.5936 18.3247 15.5936H14.576C14.1767 15.5936 13.853 15.9764 13.853 16.4487V31.9387C13.853 31.9508 13.8532 31.9628 13.8536 31.9747H9.00378C9.00422 31.9628 9.00443 31.9508 9.00443 31.9387V16.4487C9.00443 15.9764 8.68067 15.5936 8.28134 15.5936H4.53264Z"
        fill={palette.mediumGray}
      />
    </SVGResponsive>
  )
}

export default React.memo(Bank)
